var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 17,
    viewBox: "0 0 101 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.63637 12.628L3.26705 16.5058L5.38353 10.199L5.60284e-06 6.30695H6.59091L8.63637 0.000132084L10.6818 6.30695H17.2727L11.8892 10.199L14.0057 16.5058L8.63637 12.628ZM29.5543 12.628L24.185 16.5058L26.3015 10.199L20.918 6.30695H27.5089L29.5543 0.000132084L31.5998 6.30695H38.1907L32.8072 10.199L34.9237 16.5058L29.5543 12.628ZM50.4723 12.628L45.103 16.5058L47.2195 10.199L41.8359 6.30695H48.4269L50.4723 0.000132084L52.5178 6.30695H59.1087L53.7251 10.199L55.8416 16.5058L50.4723 12.628ZM71.3903 12.628L66.021 16.5058L68.1374 10.199L62.7539 6.30695H69.3448L71.3903 0.000132084L73.4357 6.30695H80.0266L74.6431 10.199L76.7596 16.5058L71.3903 12.628ZM92.3082 12.628L86.9389 16.5058L89.0554 10.199L83.6719 6.30695H90.2628L92.3082 0.000132084L94.3537 6.30695H100.945L95.5611 10.199L97.6776 16.5058L92.3082 12.628Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.26c4daca9e24fd1559b3292932d68b5b.svg";
export { ForwardRef as ReactComponent };